import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-column-settings` component represents a settings window for a column.
 */
export class ChGridColumnSettings {
    constructor() {
        this.column = undefined;
        this.show = false;
    }
    windowClosedHandler(eventInfo) {
        eventInfo.stopPropagation();
        this.column.showSettings = false;
    }
    columnSettingsChangedHandler() {
        this.column.showSettings = false;
    }
    render() {
        return (h(Host, null, h("ch-window", { modal: true, container: this.column, xAlign: "inside-start", yAlign: "outside-end", caption: this.column.columnName, closeText: "Close", closeOnOutsideClick: true, closeOnEscape: true, allowDrag: "header", hidden: !this.show, exportparts: "mask,window,header,caption,close,main,footer" }, h("slot", null))));
    }
    static get is() { return "ch-grid-column-settings"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-column-settings.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-column-settings.css"]
        };
    }
    static get properties() {
        return {
            "column": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChGridColumnElement",
                    "resolved": "HTMLChGridColumnElement",
                    "references": {
                        "HTMLChGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The `HTMLChGridColumnElement` that the settings window is associated with."
                }
            },
            "show": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the settings window is currently shown or not."
                },
                "attribute": "show",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get listeners() {
        return [{
                "name": "windowClosed",
                "method": "windowClosedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "columnSettingsChanged",
                "method": "columnSettingsChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=ch-grid-column-settings.js.map
